export default "__VITE_ASSET__DUuY9tnE__"